import React from 'react';
import classNames from 'classnames';



export default class extends React.Component {

    constructor(props) {

        var {log = console.log, sortBy = undefined, selection = {}, selectionStyle, filter = '', sortOrder = undefined, onSelectionChange, rows, columns, ...otherProps} = props;

        super(props);

        this.log = log;
        this.debug = log;

        this.otherProps = otherProps;

        this.state = {};
        this.state.sortOrder = sortOrder;
        this.state.filter = filter;
        this.state.sortBy = sortBy;
        this.state.rows = rows;

        this.state.rowOrder = this.state.rows.map((row, index) => {
            return index;
        });

        this.props.columns.forEach((column, index) => {
            if (column.text == undefined && typeof column.value == 'function')
                column.text = column.value;
        });

        this.state.rowFilter = this.computeRowFilter(this.state.filter);
        this.state.rowOrder = this.computeRowOrder(this.state.sortBy, this.state.sortOrder);
        this.state.rowSelection = {};

        


    }

    componentDidMount() {
    }

    renderCell(cell, rowIndex, columnIndex) {

        let column = this.props.columns[columnIndex];
        let props = {};

        props.key = columnIndex;
        props.index = columnIndex;
        props.className = '';

        switch(column.align) {
            case 'left':
                props.className = classNames(props.className, 'text-start');
                break;
            case 'right':
                props.className = classNames(props.className, 'text-end');
                break;
            case 'center':
                props.className = classNames(props.className, 'text-center');
                break;
        }

        return (
            <td {...props}>
                {cell}
            </td>
        );

    }

    renderRow(row, rowIndex) {

        let props = {};

        props.key = rowIndex;
        props.index = rowIndex;
        props.className = '';


        
        if (this.state.rowSelection[rowIndex])
            props.className = classNames(props.className, 'table-primary ');

        props.onClick = (event) => {
            let target = event.target.parentNode;
            let index = target.attributes['index'].value;
            let row = this.state.rows[index];

            let rowSelection = this.state.rowSelection;

            switch(this.props.selectionStyle) {
                case 'multiple': {
                    if (rowSelection[index])
                        delete rowSelection[index];
                    else
                        rowSelection[index] = row;
                    break;
                }
                case 'single': {
                    rowSelection = {};
                    rowSelection[index] = row;
                    break;
                }

            }

            if (typeof this.props.onSelectionChange == 'function') {
                let selectedRows = [];
                
                for (let key in rowSelection) {
                    selectedRows.push(this.state.rows[key]);
                }

                this.props.onSelectionChange(selectedRows);
            }

            this.setState({rowSelection:rowSelection});
        };


        let cells = this.props.columns.map((column, columnIndex) => {

            let content = undefined;

            if (content == undefined)
                content = column.content;

            if (content == undefined)
                content = column.text; 

            if (content == undefined)
                content = column.value; 

            if (typeof(content) == 'function') 
                content = content(row, rowIndex, columnIndex)

            return this.renderCell(content, rowIndex, columnIndex);
        });

        return (
            <tr {...props}>
                {cells}
            </tr>
        );
    }

    renderRows() {

        return this.state.rows.map((row, rowIndex) => {
            
            try {
                // Translate the row index accordning to sorting
                if (this.state.rowOrder) {
                    rowIndex = this.state.rowOrder[rowIndex];
                    row = this.state.rows[rowIndex];
                }

                if (!this.state.rowFilter || this.state.rowFilter[rowIndex])
                    return this.renderRow(row, rowIndex);

            }
            catch(error) {
                debugger;
            }
        });            

    }

    renderColumn(column, columnIndex) {

        let props = {};

        props.key = columnIndex;
        props.index = columnIndex;
        props.className = '';
        props.style = {fontSize:'90%', ...column.style};

        switch(column.align) {
            case 'left':
                props.className = classNames(props.className, 'text-start');
                break;
            case 'right':
                props.className = classNames(props.className, 'text-end');
                break;
            case 'center':
                props.className = classNames(props.className, 'text-center');
                break;
        }
    
        // Must have a backgroiund color if fixed header
        props.style.background = 'var(--bs-light)';        

        let onColumnClick = (event) => {

            let index = event.target.attributes['index'].value;

            if (this.props.columns[index] != undefined) {
                let column = this.props.columns[index];
    
                if (column.value) {
    
                    let rows = this.state.rows;
                    let sortOrder = this.state.sortOrder;
                    let sortBy = this.state.sortBy;
                    let rowOrder = this.state.rowOrder;
    
                    if (sortOrder == 'descending' || sortBy != index) {
                        rowOrder = rowOrder.sort((a, b) => {
                            let rowA = rows[a];
                            let rowB = rows[b];
                            return column.value(rowA) > column.value(rowB);
                        });
    
                        sortOrder = 'ascending';
                    }
                    else {
                        rowOrder = rowOrder.sort((a, b) => {
                            let rowA = rows[a];
                            let rowB = rows[b];
                            return column.value(rowA) < column.value(rowB);
                        });
    
                        sortOrder = 'descending';
                    }
    
                    this.setState({rowOrder:rowOrder, sortBy:index, sortOrder:sortOrder});
                }
            }            
        }


        if (typeof(column.value) == 'function') {

            props.onClick = onColumnClick;

        }
        let renderSort = () => {

            let symbol = undefined;
            let sort = this.state.sortBy == columnIndex ? this.state.sortOrder : undefined;
            
            let style = {};
            style.fontSize = '75%';

            switch(sort) {
                case 'ascending':
                    symbol = '▲';
                    break;
                case 'descending':
                    symbol = '▼';
                    break;

                // Use opacity 0 with same symbol to keep column widths the same
                default:
                    symbol = '▼';
                    style.opacity = 0;
                    break;
            }
    
            if (symbol != undefined)
                return <span style={style} className='align-middle px-1'>{symbol}</span>
    
        }
        return (
            <th {...props}>
                {column.name}
                {renderSort()}
            </th>
        );
    }




    renderColumns() {
        let columns = this.props.columns.map((column, columnIndex) => {
            return this.renderColumn(column, columnIndex);
        });

        return (
            <tr>
                {columns}
            </tr>

        );            

    }

    renderHeader() {
        let style = {};

        style.position = 'sticky';
        style.top = 0;    

        return (
            <thead style={style}>
                {this.renderColumns()}
            </thead>

        );

    }

    renderBody() {
        return (
            <tbody>
                {this.renderRows()}
            </tbody>
        );
    };


    computeRowOrder(sortBy, sortOrder) {

        let column = this.props.columns[sortBy];
        let rows = this.state.rows;

        if (column == undefined || column.value == undefined) {
            this.log('Not able to sort.');
            return null;
        }


        this.log('sorting by column', column);
        this.log('Sort Order', sortBy, sortOrder);

        let rowOrder = this.state.rowOrder.sort((a, b) => {
            let rowA = rows[a];
            let rowB = rows[b];
            let valueA = column.value(rowA);
            let valueB = column.value(rowB);

            let compare = valueA > valueB;

            return sortOrder == 'ascending' ? compare : !compare;


        });

        return rowOrder;
    }


    computeRowFilter(filter) {

        let rows = this.state.rows;

        if (typeof filter != 'string')
            return null;

        filter = filter.toUpperCase();

        let filterRow = (row) => {

            if (filter == '')
                return row;

            for (let column of this.props.columns) {
                if (column.text) {
                    let value = column.text(row);
                    if (value) {
                        let text = value.toString();

                        if (text.toUpperCase().includes(filter)) {
                            return row;

                        }
                    }
                }
            }

        };

        let rowFilter = {};

        rows.forEach((row, index) => {
            if (filterRow(row))
                rowFilter[index] = row;

        })

        return rowFilter;

    }



    renderTable() {
        let style = {cursor:'default'};
        let className = 'table table-hover';

        return (
            <table className={className} style={style}>
                {this.renderHeader()}
                {this.renderBody()}

            </table>
        );
    }


    setFilter(filter) {
        this.setState({filter:filter, rowFilter:this.computeRowFilter(filter)});
    }


    setRows(rows) {
        this.setState({rows:rows, filter:this.state.filter, rowFilter:this.computeRowFilter(this.state.filter)});
    }

    setSelection(selection) {
        this.setState({selection:selection});
    }

    select() {
        this.state.rowSelection = {};
        this.forceUpdate();

    }

    render() {

        this.debug('Rendering List');

        return (
                <div {...this.otherProps}> 
                    {this.renderTable()}
                </div>



        );
    }


}
